module.exports = __webpack_public_path__ + "img/Lambda.49f54642.png";